exports.URL = "https://guest.onasystem.com/data/";
//exports.TEST = true;
exports.TEST = false;// process.env.NODE_ENV !== 'production';